module.exports = __webpack_public_path__ + "img/zl14.58296a3f.png";